<template>
  <b-container fluid>
    <b-row style="margin-bottom: 1rem;" align-h="between">
      <template
        v-if="
          object.fowlcategory.options.length > 0 &&
            object.country.options.length > 0 &&
            object.year.options.length > 0
        "
      >
        <b-col cols="10">
          <span>
            縣市別:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
              v-model="object.country.value"
              :options="object.country.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <span>
            家禽別:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 15vh; display: inline-grid; margin-right: 10px;"
              v-model="object.fowlcategory.value"
              :options="object.fowlcategory.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
          <span>
            年度:
          </span>
          <span>
            <v-select
              style="min-width:fit-content; width: 15vh; display: inline-grid; margin-right: 10px;"
              v-model="object.year.value"
              :options="object.year.options"
              :selectable="(y) => y.disabled"
            ></v-select>
          </span>
        </b-col>
      </template>
      <template v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </template>
    </b-row>
    <template v-if="object.table.ifshow">
      <b-row>
        <b-col>
          <b-table
            :items="object.table.items"
            :fields="object.table.fields"
            :current-page="object.table.currentPage"
            :per-page="object.table.perPage"
            :busy="object.table.isBusy"
            head-variant="green"
            responsive
            striped
            hover
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col>
          <b-pagination
            v-model="object.table.currentPage"
            :total-rows="object.table.totalRows"
            :per-page="object.table.perPage"
            small
          ></b-pagination>
        </b-col>
        <b-col cols="auto">
          <span>共 {{ object.table.totalRows }}筆資料</span>
        </b-col>
      </b-row> -->
    </template>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      object: {
        fowlcategory: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        country: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        year: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
        },
        table: {
          ifshow: false,
          fields: [
            {
              key: "PS_CITY",
              label: "縣市別",
              visible: true,
            },
            {
              key: "PS_TYPE",
              label: "家畜別",
              visible: true,
            },
            {
              key: "PS_YEAR",
              label: "年份",
              visible: true,
            },
            {
              key: "PS_NUMS",
              label: "數值",
              visible: true,
            },
            {
              key: "PS_UNIT",
              label: "單位",
              visible: true,
            },
          ],
          items: [],
          allitems: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
      },
      apiGetPoultryCityList: (data) =>
        this.userRequest.post("/API/Default/getPoultryCityList", data),
      apiGetPoultryTypeList: (data) =>
        this.userRequest.post("/API/Default/getPoultryTypeList", data),
      apiGetPoultryDateList: (data) =>
        this.userRequest.post("/API/Default/getPoultryDateList", data),
      apiPoultryDataList: (data) =>
        this.userRequest.post("/API/Default/getPoultryDataList", data),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.FunctionToken(this.getPoultryCityList, {});
      this.FunctionToken(this.getPoultryTypeList, {});
      this.FunctionToken(this.getPoultryDateList, {});
    },
    getPoultryCityList(data) {
      this.apiGetPoultryCityList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.country.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.PS_CITY,
                code: x.PS_CITY,
                disabled: true,
              };
              this.object.country.options.push(obj);
            });
            this.object.country.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.country.value = {
              label: "嘉義縣",
              code: "嘉義縣",
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getPoultryTypeList(data) {
      this.apiGetPoultryTypeList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.fowlcategory.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.PS_TYPE,
                code: x.PS_TYPE,
                disabled: true,
              };
              this.object.fowlcategory.options.push(obj);
            });
            this.object.fowlcategory.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.fowlcategory.value = {
              label: "雞",
              code: "雞",
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getPoultryDateList(data) {
      this.apiGetPoultryDateList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.year.options = [];
            let arr = JSON.parse(json.Data);
            //console.log("arr",arr)
            arr.forEach((x) => {
              let obj = {
                label: x.PS_YEAR,
                code: x.PS_YEAR,
                disabled: true,
              };
              this.object.year.options.push(obj);
            });
            this.object.year.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            this.object.year.value = {
              label: arr[0].PS_YEAR,
              code: arr[0].PS_YEAR,
              disabled: true,
            };
          }
        })
        .catch((err) => console.warn(err));
    },
    getPoultryDataList(data) {
      this.apiPoultryDataList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.object.table.items = JSON.parse(json.Data);
            this.object.table.totalRows = this.object.table.items.length;
            this.object.table.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getDataList() {
      if (
        this.object.fowlcategory.value != null &&
        this.object.country.value != null &&
        this.object.year.value != null
      ) {
        this.object.table.isBusy = true;
        this.object.table.ifshow = true;
        this.FunctionToken(this.getPoultryDataList, {
          PS_TYPE: this.object.fowlcategory.value.code,
          PS_CITY: this.object.country.value.code,
          PS_YEAR: this.object.year.value.code,
        });
      }
    },
    // handleResize() {
    //   this.object.window.width = window.innerWidth;
    // },
  },
  watch: {
    "object.fowlcategory.value"() {
      this.getDataList();
    },
    "object.country.value"() {
      this.getDataList();
    },
    "object.year.value"() {
      this.getDataList();
    },
  },
};
</script>
